// Figures (Primitives; was primitives.tsx's, HIERARCHY follow-up 9, BL-189): a title block's figures, at
// most five in a row: each its label, its value and a muted line under it, a rule above and below the
// strip and a hairline between them; two to a row on a phone. A figure that stands for a page opens it
// (Home's "Owed to you"): a button drawn as the figure, its label underlined on hover. Figure is one on
// its own (a record's facts). They keep base.css's classes (.flw-figs, .flw-fig), which page sheets
// place by. Reads only --figures-*.
import type { ReactNode } from 'react';
import './Figures.css';

export interface FigureProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
}

export function Figure({ label, value, sub }: FigureProps) {
  return (
    <div className="flw-fig">
      <span>{label}</span>
      <b>{value}</b>
      {sub != null && <small>{sub}</small>}
    </div>
  );
}

export interface FigureItem extends FigureProps {
  /** The page the figure stands for, if it opens one (Home's "Owed to you" opens who owes what). */
  onOpen?: () => void;
}

export interface FiguresProps {
  /** At most five; any more aren't drawn. */
  items: readonly FigureItem[];
}

/** A title block's figures: at most five in a row, a rule above and below, hairlines between. */
export function Figures({ items }: FiguresProps) {
  return (
    <div className="flw-figs">
      {items.slice(0, 5).map((f) =>
        f.onOpen ? (
          <button key={f.label} type="button" className="flw-fig flw-fig-open" onClick={f.onOpen}>
            <span>{f.label}</span>
            <b>{f.value}</b>
            {f.sub != null && <small>{f.sub}</small>}
          </button>
        ) : (
          <Figure key={f.label} label={f.label} value={f.value} sub={f.sub} />
        ),
      )}
    </div>
  );
}
